import React from 'react';
import { FaPalette } from 'react-icons/fa';
import SharedHeader from '../../../components/SharedHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import UnderConstruction from '../../../components/UnderConstruction';
import './marketing_designs.css';

const MarketingDesigns = () => {
  return (
    <div className="marketing_designs_page">
      <SharedHeader />
      
      <div className="marketing_designs_container">
        <header className="marketing_designs_header">
          <div className="marketing_designs_header_icon">
            <FaPalette />
          </div>
          <h1>Marketing Designs</h1>
          <p>Create and manage your marketing designs</p>
        </header>

        {/* Under Construction Notice */}
        <UnderConstruction pageName="Marketing Designs" />
      </div>

      <DashboardFooter />
    </div>
  );
};

export default MarketingDesigns; 